export default __webpack_public_path__ + "static/nimbus_bold-a82d15a107c962654ca321a3c2ec12f3.ttf";